import { useAxios } from './axiosApi';

export function usePathApi() {
  const { apiPost } = useAxios();
  return {
    // Fetch pre-signed URLs for a given set of userPath-relative files.
    getPresignedUrls: async (fileUserPaths, userId) => {
      const dataIn = {
        userId,
        mode: 'getObject',
        fileUserPaths,
      };
      const response = await apiPost('/path', dataIn);
      const { status, data } = response.data;
      if (status == 'success') {
        return data.urls;
      } else {
        console.log('getPresignedUrls failed:', status, data);
      }
    },
  }
}
